import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetTriggerResponseTO, Trigger } from 'models/automation/Triggers';
import API from 'services/API';
import { TRIGGERS_BASE_QUERY_KEY } from './triggersQuery';

type ReactQueryOptions = Omit<UseQueryOptions<Trigger>, 'queryKey' | 'queryFn'>;

type UseFetchTriggerArgs = ReactQueryOptions & {
  triggerUid?: string | null;
};

const useFetchTrigger = ({
  enabled = true,
  triggerUid,
  ...options
}: UseFetchTriggerArgs) => {
  return useAppQuery<Trigger>({
    queryKey: [TRIGGERS_BASE_QUERY_KEY, 'detail', triggerUid],
    queryFn: async () => {
      const response = await API.get<GetTriggerResponseTO>(
        `/api/internal/triggers/${triggerUid}`,
      );

      return response.data.trigger;
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchTrigger;
